<template>
  <v-row justify="center">
    <v-dialog
      persistent
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn color="primary" dark v-bind="attrs" v-on="on">Open editor</v-btn>
      </template>
      <v-card height="100%">
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Edit polygons</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark text @click="save()">Save</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <!-- <polygons-canvas :canvas-id="'canvas-one'" ref="childCanvas"></polygons-canvas> -->
        <open-sea-dragon-viewer
          :id="'osd-viewer'"
          :options="{
            defaultZoomLevel: 1,
            minZoomLevel: 1,
            maxZoomLevel: 5,
            ajaxWithCredentials: false,
            showNavigator: false,
            showNavigationControl: false,
            showReferenceStrip: false,
            homeFillsViewer: true,
            constrainDuringPan: true,
            visibilityRatio: 1,
            iOSDevice: true,
            loadTilesWithAjax: true,
            ajaxWithCredentials: true,
            // ajaxHeaders: {
            // Example of using the viewer-level ajaxHeaders option
            // for providing an authentication token.
            //  Authorization: 'Bearer ' + apiCredentials
            // },
            animationTime: 0.5,
            immediateRender: true
          }"
          :tile-sources="currentTileSources"
        />
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import PolygonsCanvas from '../components/PolygonsCanvas'
import OpenSeaDragonViewer from '../components/Polygons/OpenSeadragonViewer'
import OpenSeadragonMixin from '../mixins/OpenSeadragonMixin'
import Enums from '../helpers/Enums'

import { mapGetters, mapState } from 'vuex'

export default {
  data() {
    return {
      name: '',
      dialog: false,
      displayedMedia: null,
      currentTileSources: null,
      apiCredentials: window.localStorage.apiCredentials
    }
  },
  components: {
    // eslint-disable-next-line vue/no-unused-components
    'open-sea-dragon-viewer': OpenSeaDragonViewer
  },
  computed: {
    ...mapGetters('ContentStore', [
      'getMasterplanTitle',
      'getSelectedMasterplanTitle',
      'getBuildingTitle'
    ]),
    ...mapState('ContentStore', ['selectedMasterplan'])
    //...mapState("AuthStore", ["apiCredentials"]),
  },
  mixins: [OpenSeadragonMixin],
  created: function() {},
  methods: {
    async init(masterplanId, viewId = 0) {
      if (this.$store.state.ContentStore.contentData === null) {
        await this.$store.dispatch('ContentStore/getAllContentData')
      }
      let self = this
      console.log('masterplanId', masterplanId)
      try {
        if (isNaN(masterplanId)) {
          masterplanId = 3 //TODO should get root masterplanId from config
        }

        let selectedMasterplan = this.$store.getters[
          'ContentStore/getMasterplanById'
        ](masterplanId)

        this.$store.dispatch(
          'ContentStore/setSelectedMasterplan',
          selectedMasterplan
        )
        this.masterplanImages = this.$store.getters[
          'ContentStore/getSelectedMasterplanImages'
        ]
        console.log('masterplanImages', this.masterplanImages, 'viewId', viewId)
        if (viewId === 0) {
          this.displayedMedia = this.masterplanImages[0]
        } else {
          this.displayedMedia = this.masterplanImages.find(m => m.id === viewId)
          if (!this.displayedMedia) {
            this.displayedMedia = this.masterplanImages[0]
          }
        }

        console.log('media ', this.displayedMedia)
        this.currentTileSources = this.getOsdTileSources([this.displayedMedia])

        // this.masterplanImageSrcs = []
        // masterplanImages.map(async (image, i) => {
        //   const response = await this.getMedia(
        //     image,
        //     image.PoiContent.poisId,
        //     Enums.MediaContext.poi
        //   )
        //   this.$set(this.masterplanImageSrcs, i, response)
        // })

        //get masterplan (building complex) buildings if any
        const masterplanInfoPoi = this.$store.getters[
          'ContentStore/getMasterplanInfoPoi'
        ](selectedMasterplan)
        const poiData = this.$store.getters['ContentStore/getPoiData'](
          masterplanInfoPoi
        )
        this.childBuildings = []
        this.childMasterplans = []
        if (poiData) {
          if (poiData.Masterplans) {
            this.childMasterplans = poiData.Masterplans.map(d => {
              return self.$store.getters['ContentStore/getMasterplanById'](d.id)
            })
          } else if (poiData.Buildings) {
            this.childBuildings = poiData.Buildings.map(b => {
              return self.$store.getters[
                'ContentStore/getMasterplanBuldingById'
              ](selectedMasterplan, b.id)
            })
          }
        }
        //set app title bar
        this.$emit(
          'onTitleChange',
          this.$store.getters['ContentStore/getSelectedMasterplanTitle']
        )
        //set app context
        console.log(
          'this.selectedMasterplan.parentId',
          this.selectedMasterplan.parentId
        )
        if (this.selectedMasterplan.parentId === 0) {
          this.$emit('onAppContext', Enums.AppContext.context_masterplans)
        } else {
          this.$emit('onAppContext', Enums.AppContext.context_child_masterplans)
        }
      } catch (ex) {
        console.error(ex)
      } finally {
        console.log('Got data')
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      console.log('enter', vm.$route.params.id)
      return vm.init(parseInt(vm.$route.params.id), parseInt(to.params.viewId))
    })
  },
  async beforeRouteUpdate(to, from, next) {
    console.log('update', to.params.id)
    this.init(parseInt(to.params.id), parseInt(to.params.viewId))
    next()
  }
}
</script>

<style scoped></style>
